<template lang="pug">
.auth
  .auth_left
    v-img.auth_left_img(src="@/assets/login.png")
    i18n(:path="isReferrerUrl ? 'label.login_title.emanat' : 'label.login_title'" tag="h2" class="main-auth-label auth-label-margin-top font-weight-medium")
      span(place="easy" :class="isReferrerUrl ? 'referrerUrl'  : ''") {{$t('misc.common.easy')}}
    p.auth_left_p.text.auth-description-color.login-description-line-height {{ $t('label.login_description_new') }}
  .auth_right
    AppFrame(frameTitle="misc.auth.account.complete.registration" :frameContents="frameContents")
    .auth_right_desktop
      h3.auth_right_desktop_h3 {{ $t('misc.auth.with_account') }}
      router-link.auth_right_desktop_link(:to="{ name: 'login' }") {{ $t('action.sign_in') }}
  AppAuthModal(:isAuthModalVisibility="true" :isRegisterPage="true")
</template>
<script>
import { ValidationRequired } from '@/rules/required';
import { RegisterRequests } from '@/services/http/register-requests';
import { UserService } from '@/services/user-service';
import timerMixin from '@/mixins/timer';
import { i18n } from '@/i18n';
import { ValidationPattern } from '@/rules/pattern';
import AppFrame from '@/views/auth/components/AppFrame';
import AppAuthModal from '@/views/auth/components/AppAuthModal';

export default {
  name: 'RegistrationPage',
  components: {
    AppFrame,
    AppAuthModal,
  },
  mixins: [timerMixin],
  data() {
    return {
      registerForm: true,
      get isReferrerUrl() {
        return !!sessionStorage.getItem('referrerUrl');
      },
      step: 1,
      otpExpireTime: 0,
      token: '',
      otp: '',
      message: '',
      passwordNotMatch: '',
      ruleLength: 0,
      phone: '',
      items: [
        {
          title: i18n.t('label.register_title1'),
          description: i18n.t('label.register_description1'),
        },
        {
          title: i18n.t('label.register_title2'),
          description: i18n.t('label.register_description2'),
        },
        {
          title: i18n.t('label.register_title3'),
          description: i18n.t('label.register_description3'),
        },
      ],
      frameContents: [
        'misc.auth.open.camera',
        'misc.auth.scan.qr',
        'misc.auth.download.app',
      ],
      loading: false,
      auth: {
        username: {
          masked: '',
          unmasked: '',
          completed: false,
        },
        password: '',
        passwordConfirmation: '',
      },
      options: {
        eager: true,
        mask: '## ### ## ##',
      },
      rules: {
        username: [ValidationRequired()],
        password: [
          ValidationRequired(),
          ValidationPattern('^\\S*$', 'label.register_error.whitespace'),
          ValidationPattern('(.*[A-Z].*)', 'label.auth.uppercase'),
          ValidationPattern('(.*[a-z].*)', 'label.auth.lowercase'),
          ValidationPattern('(.*\\d.*)', 'label.auth.number'),
          ValidationPattern('(.*\\W.*)', 'label.auth.character'),
          ValidationPattern('(.{8,})', 'label.auth.least_symbol'),
          ValidationPattern('(.{1,30})', 'label.auth.most_symbol'),
        ],
        confirm_password: [ValidationRequired()],
      },
      rulesTooltip: [
        { message: 'label.auth.min_max_symbols', regex: /.{8,30}/, status: false },
        { message: 'label.auth.uppercase', regex: /[A-Z]+/, status: false },
        { message: 'label.auth.lowercase', regex: /[a-z]+/, status: false },
        { message: 'label.auth.number', regex: /[0-9]+/, status: false },
        { message: 'label.auth.character', regex: /\W+/, status: false },
      ],
      showPassword: false,
      showPasswordConfirmation: false,
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  // mounted() {
  //   if (this.$route.name === 'otp') {
  //     this.step = localStorage.getItem('registerStep') || 1;
  //     return false;
  //   }
  //   localStorage.clear();
  //   return '';
  // },
  methods: {
    checkPasswordStrength() {
      this.rulesTooltip.forEach((condition) => {
        if (condition.regex.test(this.auth.password)) {
          condition.status = true;
        } else {
          condition.status = false;
        }
      });
      this.ruleLength = this.rulesTooltip.filter((rule) => rule.status === true).length;
    },
    checkPasswordMatch() {
      if (!this.auth.passwordConfirmation) return false;
      if (this.auth?.password !== this.auth?.passwordConfirmation) {
        this.passwordNotMatch = i18n.t('label.register_error.match');
      } else this.passwordNotMatch = '';
      return true;
    },

    async register() {
      if (!this.$refs.register.validate()) {
        return;
      }

      this.loading = true;

      const [response, error] = await RegisterRequests.register({
        username: `+994${this.auth.username.unmasked}`,
        password: this.auth.password,
      });

      this.loading = false;

      if (error) {
        this.message = error.errorDetails[0].message;
        this.$notify.error(error.errorDetails[0].message);
      } else {
        console.log(response);
        if (response?.data?.otpRequired) {
          // localStorage.setItem('registerStep', 2);
          this.step = 2;
          // this.$router.push({ name: 'otp' });
          this.otpExpireTime = response?.data?.otpExpireTime;
          this.token = response?.data?.token;
          this.setTimer(this.otpExpireTime);
        }
      }
    },
    async confirm() {
      this.loading = true;
      const [response, error] = await RegisterRequests.confirm({
        token: this.token,
        otp: this.otp,
      });
      this.loading = false;
      if (error) {
        this.message = error.errorDetails[0].message;
      } else {
        clearInterval(this.countdownTimer);
        localStorage.setItem('new-user', true);
        UserService.login(response.data.token);
        this.$router.replace({ name: 'dashboard-root' });
      }
    },
    async sendAgain() {
      this.loading = true;
      const [response, error] = await RegisterRequests.register({
        username: `+994${this.auth.username.unmasked}`,
        password: this.auth.password,
      });
      this.loading = false;
      clearInterval(this.countdownTimer);
      if (error) {
        this.message = error.errorDetails[0].message;
      } else {
        this.otpExpireTime = response?.data?.otpExpireTime;
        this.setTimer(this.otpExpireTime);
        this.token = response?.data?.token;
        this.otp = '';
        this.message = '';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/auth.scss';
.auth_modal {
  top: 0;
}
.password {
  position: relative;
  a {
    position: absolute;
    top: 5px;
    right: 0;
  }
}
.register-info-title{
  font-size: 16px;
  font-weight: 500;
}
.register-info-description{
  font-size: 14px;
  font-weight: 400;
}
@media (max-width: 1263px) {
  .auth {
    justify-content: space-around;
  }
}
</style>
